import React from 'react';
import { Link, NavLink, Outlet } from 'react-router-dom';
import { Button } from './ui/Button';
import { Wordmark } from './Wordmark';
const navLinks = [{
  to: '/',
  label: 'How it works'
}, {
  to: '/pricing',
  label: 'Pricing'
}];
export function MarketingShell() {
  return <div className="flex min-h-full w-full flex-col bg-canvas" data-id="element-360" data-mp="2ohrbrnm80ihd">
      <header className="sticky top-0 z-30 border-b border-line bg-surface/95 backdrop-blur" data-id="element-361" data-mp="2ogg61i97t0nm">
        <div className="mx-auto flex h-16 w-full max-w-page items-center gap-6 px-5 sm:px-8" data-id="element-362" data-mp="32fplgfpljqqj">
          <Link to="/" className="flex items-center gap-2 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand" data-id="element-363" data-mp="2xhwehkggysp7">
            <Wordmark size="sm" data-id="element-364" data-mp="378r0qotptsan" />
          </Link>

          <nav aria-label="Main" className="hidden items-center gap-1 sm:flex" data-id="element-365" data-mp="3l7ie290r79xq">
            {navLinks.map(link => <NavLink key={link.to} to={link.to} end className={({
            isActive
          }) => `rounded-control px-3 py-1.5 text-sm transition-colors duration-150 ease-snap ${isActive ? 'bg-canvas text-ink' : 'text-ink-muted hover:bg-canvas hover:text-ink'}`} data-id="element-366" data-mp="3h7gbzyr3wehx">
                {link.label}
              </NavLink>)}
          </nav>

          <div className="ml-auto flex items-center gap-2" data-id="element-367" data-mp="27u5w1hycwaof">
            <Button variant="ghost" size="sm" to="/login" data-id="element-368" data-mp="2bv7v9ys9wmqe">
              Log in
            </Button>
            <Button size="sm" to="/signup" data-id="element-369" data-mp="2gmg8z70myu9d">
              Start monitoring
            </Button>
          </div>
        </div>
      </header>

      <main className="flex-1" data-id="element-370" data-mp="2ll1ad9rmjjze">
        <Outlet data-id="element-371" data-mp="2ql5owu8z24mz" />
      </main>

      <footer className="bg-shell" data-id="element-372" data-mp="2qlymb4m1jhsg">
        <div className="mx-auto grid w-full max-w-page gap-10 px-5 py-14 sm:px-8 md:grid-cols-[1.6fr_1fr_1fr_1fr]" data-id="element-373" data-mp="2qisyrtt28nyu">
          <div data-id="element-374" data-mp="25vuqmu95k4r7">
            <div className="flex items-center gap-2" data-id="element-375" data-mp="25vl8fsucn1w2">
              <Wordmark tone="dark" size="sm" data-id="element-376" data-mp="25w4gmhu76bww" />
            </div>
            <p className="mt-3 max-w-xs text-[13px] leading-relaxed text-white/60" data-id="element-377" data-mp="20xt8cbjjw9gs">
              Certificate expiry and uptime monitoring for people who would
              rather hear it from us than from a customer.
            </p>
            <p className="mt-5 font-mono text-[11px] text-white/45" data-id="element-378" data-mp="2atmummn2nhbr">
              Certificates swept daily at 08:00 · uptime pinged from three
              regions
            </p>
          </div>

          <div data-id="element-379" data-mp="2jmzw4cz7br9g">
            <h2 className="text-[13px] font-semibold text-white" data-id="element-380" data-mp="2jpm0k3qspqng">Product</h2>
            <ul className="mt-3 space-y-2 text-[13px] text-white/60" data-id="element-381" data-mp="2yjqxgrsfrd1p">
              <li data-id="element-382" data-mp="2tmgyolj5pp17">
                <Link to="/" className="hover:text-white" data-id="element-383" data-mp="2tlysaw2s5ufk">
                  SSL expiry alerts
                </Link>
              </li>
              <li data-id="element-384" data-mp="z7edh0154t43">
                <Link to="/" className="hover:text-white" data-id="element-385" data-mp="z7xvegqsjhi4">
                  Uptime monitoring
                </Link>
              </li>
              <li data-id="element-386" data-mp="3aw2te97axkxg">
                <Link to="/pricing" className="hover:text-white" data-id="element-387" data-mp="3awunffl93alm">
                  Pricing
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-388" data-mp="313x2l2ssd9ju">
            <h2 className="text-[13px] font-semibold text-white" data-id="element-389" data-mp="314f3wdub2dym">Account</h2>
            <ul className="mt-3 space-y-2 text-[13px] text-white/60" data-id="element-390" data-mp="362zv5nrkxnax">
              <li data-id="element-391" data-mp="2s4i9dvl8ikvn">
                <Link to="/login" className="hover:text-white" data-id="element-392" data-mp="2s40g97tvcmry">
                  Log in
                </Link>
              </li>
              <li data-id="element-393" data-mp="2w7ey841dbd81">
                <Link to="/signup" className="hover:text-white" data-id="element-394" data-mp="2w3r4b3s0goss">
                  Create an account
                </Link>
              </li>
              <li data-id="element-395" data-mp="2n4dsi4gezo4w">
                <Link to="/app" className="hover:text-white" data-id="element-396" data-mp="2n5yntwajzb3t">
                  Dashboard
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-397" data-mp="ldk730jqwcoz">
            <h2 className="text-[13px] font-semibold text-white" data-id="element-398" data-mp="le2d2ow7m5a3">Company</h2>
            <ul className="mt-3 space-y-2 text-[13px] text-white/60" data-id="element-399" data-mp="2hgoywharouzj">
              <li data-id="element-400" data-mp="2heunbtldyf84">
                <Link to="/brand" className="hover:text-white" data-id="element-401" data-mp="2chughggpp8fy">
                  Brand specimen
                </Link>
              </li>
              <li data-id="element-402" data-mp="28f7lx7snp9f2">Status</li>
              <li data-id="element-403" data-mp="28efpxvv5d9o9">Privacy</li>
              <li data-id="element-404" data-mp="23h61ojjhv420">Terms</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-shell-line px-5 py-5 sm:px-8" data-id="element-405" data-mp="23gw8kn35kgs3">
          <p className="mx-auto w-full max-w-page text-xs text-white/45" data-id="element-406" data-mp="1yiutsecrf3mf">
            © {new Date().getFullYear()} watchtowerworks.com. All monitoring
            times shown in your account time zone.
          </p>
        </div>
      </footer>
    </div>;
}